import React from 'react'

import { styled, th, useStyleConfig, vui } from '@veracity/vui'
import { cs, filterUndefined } from '@veracity/vui'
import { useSelectContext } from './context'
import { SelectSelectProps, SelectState } from './select.types'

// https://yoksel.github.io/url-encoder/

export const SelectSelectBase = styled.select<{ state: SelectState | ""; }>`
	align-self: stretch;
	appearance: none;
	background-color: transparent;
	${p => p.state === "loading" ? "" : `
		background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.6016 15.3255L6.16407 9.80361C5.94376 9.58329 5.94376 9.22704 6.16407 9.00673L6.49689 8.67392C6.7172 8.45361 7.07345 8.45361 7.29376 8.67392L12 13.4692L16.7063 8.67861C16.9266 8.45829 17.2828 8.45829 17.5031 8.67861L17.8359 9.01142C18.0563 9.23173 18.0563 9.58798 17.8359 9.80829L12.3984 15.3302C12.1781 15.5458 11.8219 15.5458 11.6016 15.3255Z' fill='%230067C5'/%3E%3C/svg%3E");
		background-repeat: no-repeat;
		background-position: right 8px center;
		background-size: 24px 24px;`
	}
	border: none;
	border-radius: md;
	flex: 1;
	font-size: inherit;
	min-width: 0;
	outline: none;
	padding: 0 5 0 1;

	&::placeholder {
		color: grey.60;
	}

	&[aria-disabled='true'],
	&[aria-disabled='true']::placeholder {
		color: disabled.color;
		cursor: not-allowed;
	}
`

/** Displays an select element within the Select component. */
export const SelectSelect = vui<'select', SelectSelectProps>((props, ref) => {
	const { className, ...rest } = props
	const selectProps = useSelectContext()
	const mergedProps = { ...selectProps, ...props }
	const styles = useStyleConfig('Select', mergedProps)

	const aliasedProps = filterUndefined({
		'aria-disabled': mergedProps.disabled
	})

	return (
		<SelectSelectBase
			className={cs('vui-selectSelect', className)}
			ref={ref}
			{...styles.select}
			{...aliasedProps}
			{...rest}
		/>
	)
})

SelectSelect.displayName = 'SelectSelect'

export default SelectSelect
